<mat-form-field [class]="className">
    <mat-label>{{ label }}</mat-label>
    <input type="text" placeholder="Search..." matInput [matAutocomplete]="auto" [disabled]="disabled"
        [formControl]="inputControl">

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith"
        (optionSelected)="onSelect($event.option.value)">
        <mat-option *ngFor="let option of (filteredOptions$ | async)" [value]="option">
            {{ displayWith(option) }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>